import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { persistStore } from 'redux-persist';
import { apiBaseMiddleware } from './api/services/rtkQuery/apiBaseQuery';
import { pReducer } from './rootReducer';
import { setStore } from './storeRef';
export var store = configureStore({
  reducer: pReducer,
  devTools: true,
  // RTK 2.x: `middleware` y `enhancers` tienen que ser callbacks. Con la forma de
  // array, en dev tira error y en prod se descarta el middleware custom en silencio
  // (apiBaseMiddleware quedaba fuera y RTK Query dejaba de funcionar).
  middleware: function middleware(getDefaultMiddleware) {
    return getDefaultMiddleware({
      // redux-persist despacha acciones con valores no serializables y el state
      // persistido es grande: los checks de dev cuestan demasiado acá.
      serializableCheck: false,
      immutableCheck: false
    }).concat(apiBaseMiddleware);
  }
});

// Expose the store to the axios service layer without a direct import there
// (breaks the store -> rootReducer -> apiBaseQuery -> axios -> store require cycle).
setStore(store);
setupListeners(store.dispatch);
export var persistor = persistStore(store);
export default store;